import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const activeRowClass = "active-row";

export default class extends Controller {
  static targets = [
    "grid",
    "nextButton",
    "teamIdInput",
    "row",
    "assetLogos",
    "searchBtn",
    "resetBtn",
    "searchTextInput",
  ];

  connect() {
    this.params = JSON.parse(this.data.get("params"));

    if (this.params.limitedSearch) {
      this.searchBtnTarget.disabled = true;
      this.resetBtnTarget.classList.add("disabled");

      this.searchTextInputTarget.addEventListener("input", (e) => {
        const disabled = e.target.value.length < 3;

        this.searchBtnTarget.disabled = disabled;
        this.resetBtnTarget.classList.toggle("disabled", disabled);
      });
    }
  }

  gridTargetConnected() {
    this.rowTargets
      .find(
        (row) =>
          row.getAttribute(`data-${this.identifier}-status-param`) == "active",
      )
      ?.click();
  }

  rowClick({ currentTarget, params }) {
    this.nextButtonTarget.disabled = params.status != "active";
    this.teamId = params.id;

    this.selectedRow?.classList.remove(activeRowClass);
    this.selectedRow = currentTarget;
    this.selectedRow.classList.add(activeRowClass);

    let status =
      $("select[name=destination]").val() || $.url().qs("as") || "active";
    $(this.assetLogosTarget).reload(
      `/asset_groups/small_logos?as=${status}&organization_id=${params.id}`,
    );
  }

  editClick({ params: { url } }) {
    Turbo.visit(url.replace("id", this.teamId));
  }

  assignClick(event) {
    const url = event.currentTarget.dataset.teamGridUrlParam;
    const form = document.createElement("form");

    form.method = "POST";
    form.action = url;

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "patch";

    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = document.querySelector("meta[name='csrf-param']").content;
    csrfInput.value = document.querySelector("meta[name='csrf-token']").content;

    const teamIdInput = document.createElement("input");
    teamIdInput.type = "hidden";
    teamIdInput.name = "team_id";
    teamIdInput.value = this.teamId;

    form.appendChild(methodInput);
    form.appendChild(csrfInput);
    form.appendChild(teamIdInput);
    document.body.appendChild(form);

    form.requestSubmit();
  }

  nextClick({ params: { url } }) {
    Turbo.visit(`${url}?team_id=${this.teamId}`);
  }

  addLogoRequestClick() {
    SideDialog.load(
      `/asset_groups/new?owner_type=Organization&owner_id=${this.selectedRow.dataset.teamGridIdParam}`,
    );
  }
}
